import { DateTime } from 'luxon'

export function notificationDay(createdAt: number, now: DateTime = DateTime.local()): string {
  const date = DateTime.fromMillis(createdAt).toLocal()
  if (date.hasSame(now, 'day')) return 'Today'
  if (date.hasSame(now.minus({ days: 1 }), 'day')) return 'Yesterday'
  return 'Earlier'
}

export function notificationRelativeTime(createdAt: number, now: DateTime = DateTime.local()): string {
  const date = DateTime.fromMillis(createdAt)
  if (Math.abs(date.diff(now, 'seconds').seconds) < 60) return 'just now'
  return date.toRelative({ base: now }) ?? 'just now'
}
